import { useToast } from '@chakra-ui/react';
import { api } from 'api/api';
import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useVideoChamada = (props) => {
  const [chamadafinalizada, setChamadaFinalizada] = useState(false);
  let tentativas = 0;
  const atendimentoId = props?.agenda_exames_id ?? null;
  const toast = useToast();
  const navigate = useNavigate();

  async function getStatusChamada() {
    try {
      await api(`${ENDPOINT}/clients/getStatusChamada`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ agenda_exames_id: atendimentoId }),
      })
        .then(async (res) => {
          if (!res || !res.ok || res.status >= 400) {
            console.log(res);
            return;
          }
          return await res.json();
        })
        .then(async (resposta) => {
          if (resposta === null || resposta === undefined || resposta?.name === 'error') {
            if (tentativas === 3) {
              toast({
                title: 'Falha na chamada',
                description: 'Não foi possível atualizar o status da sua chamada. Por favor, entre em contato com o suporte',
                status: 'error',
                duration: 4000,
                isClosable: true,
                position: 'bottom',
                colorScheme: 'red',
                containerStyle: {
                  paddingTop: '50px',
                },
              });
              navigate('/dashboard');
              return;
            }
          }

          if (resposta === 'FINALIZADO' || resposta == 'FINALIZADO') {
            setChamadaFinalizada(true);
          }
        });
    } catch (error) {
      tentativas++;
      if (tentativas === 3) {
        setChamadaFinalizada(true);
      }
    }
  }

    const enterRoom = useCallback(async () => {
    if (!atendimentoId) {
      return;
    }
    try{
      await api(`${ENDPOINT}/telemedicine/enter-room`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ agenda_exames_id: atendimentoId }),
      });
    } catch (error) {
      console.log(error);
    }
  }, [atendimentoId]);

  useEffect(() => {
    enterRoom();
  }, [atendimentoId, enterRoom]);


  return {
    chamadafinalizada,
    getStatusChamada,
  };
};

export default useVideoChamada;
